<div class="mt-2">
  <div class="row">
    <div class="col-md-8 mt-4 w-100">
      <h4 class="title"><i class="far fa-hdd"></i> {{"TITLE.REPORT-STORAGE-CONSOLIDATED" | translate}}</h4>
    </div>
  </div>
</div>
<div class="row mt-2">
  <div class="col-md-2 custom-mr-17" *ngIf="hasRole(ROLE_SUPERADMIN)">
    <label class="font-weight-bold">{{ "LABEL.PARTNER" | translate }}: </label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-university"></i></div>
      </div>
      <select class="form-control"
              [(ngModel)]="partnerSelected"
              (ngModelChange)="reloadStorage()">
        <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-2 custom-mr-17" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
    <label class="font-weight-bold">{{ "LABEL.ENTERPRISE" | translate }}:</label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-building"></i></div>
      </div>
      <select class="form-control"
              [(ngModel)]="enterpriseSelected"
              (ngModelChange)="reloadStorage()">
        <option *ngFor="let enterprise of enterprises" [ngValue]="enterprise">{{enterprise.name | translate}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-2 custom-mr-17">
    <label for="dateFrom" class="font-weight-bold" data-toggle="tooltip"
           title="Seleccione el rango de fecha 'desde'.">{{ "LABEL.FROM" | translate }}: </label>
    <div class="input-group w-custom-100">
      <input id="dateFrom" #dpFromDate
             class="form-control"
             name="dpFromDate"
             (dateSelect)="onDateSelectionFrom($event)"
             [value]="formatter.format(fromDate)"
             (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
             ngbDatepicker #d="ngbDatepicker"
             [startDate]="fromDate"
             placeholder="dd/mm/yyyy">
      <button type="button" class="btn bg-transparent"  *ngIf="this.fromDate" style="margin-left: -40px; z-index: 100;" (click)="clean()">
        <i class="fa fa-times"></i>
      </button>
      <span class="custom-day"></span>
      <div class="input-group-append">
        <span class="btn btn-outline-success p-fixed"
                (click)="d.toggle()" type="button">
          <i class="far fa-calendar-alt"></i>
        </span>
      </div>
    </div>
  </div>
  <div class="col-md-2 custom-mr-17">
    <label for="dateTo"
           class="font-weight-bold" data-toggle="tooltip"
           title="Seleccione el rango de fecha 'Hasta'.">
      {{ "LABEL.TO" | translate }}: </label>
    <div class="input-group w-custom-100">
      <input id="dateTo" #dpToDate
             class="form-control custom-label-1 border-color-red"
             name="dpToDate"
             (dateSelect)="onDateSelectionTo($event)"
             [value]="formatter.format(toDate)"
             (input)="toDate = validateInput(toDate, dpToDate.value)"
             ngbDatepicker #d1="ngbDatepicker"
             placeholder="dd/mm/yyyy" style="width: 150px;">
      <button type="button" class="btn bg-transparent"  *ngIf="this.toDate" style="margin-left: -40px; z-index: 100;" (click)="clean()">
        <i class="fa fa-times"></i>
      </button>
      <div class="input-group-append align-item">
        <span class="btn btn-outline-success p-fixed"
                (click)="d1.toggle()" type="button">
          <i class="far fa-calendar-alt"></i>
        </span>
      </div>
    </div>
  </div>
  <div class="col-md-1 custom-mt-24">
    <button type="button"
            class="btn btn-outline-success custom-button"
            (click)="search()">
      <i class="fa fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
    </button>
  </div>
  <div class="col-md-1 custom-mt-24">
    <button type="button"
            class="btn btn-success dxbs-button custom-button"
            (click)="downloadReportOf()">
      <span aria-hidden="true" class="image far fa-file-excel"></span>
      {{ "BUTTON.EXPORT" | translate }}
    </button>
  </div>
</div>
<div class="table-responsive mt-2 mb-2 custom-table-height">
  <table class="table-sm table-bordered">
    <thead class="custom-font-size-table-header">
    <tr>
      <th scope="col" title="#"></th>
      <th scope="col" title="{{'TABLE.HEADER.OWNER' | translate }}" *ngIf="hasRole(ROLE_SUPERADMIN)"></th>
      <th scope="col" title="{{'TABLE.HEADER.ENTERPRISE' | translate }}"></th>
      <th scope="col" title="{{'TABLE.HEADER.SUBJECT' | translate }}"></th>
      <th scope="col" title="{{'TABLE.HEADER.SIZE' | translate }}"></th>
      <th scope="col" title="{{'TABLE.HEADER.DATE' | translate }}"></th>
      <th scope="col" title="{{'TABLE.HEADER.STATE' | translate }}"></th>
    </tr>
    </thead>
    <tr *ngIf="enterpriseStorageDetails.length<1">
      <td colspan="11" class="custom-height-500">
        {{ "MESSAGE.NO-RECORDS-AVAILABLE" | translate }}
      </td>
    </tr>
    <tbody>
    <tr *ngFor="let storage of enterpriseStorageDetails; let index=index" class="custom-font-size-table-body">
      <td title="#"><b>{{(page.number * pageNumber) + index + 1}}</b></td>
      <td title="{{'TABLE.HEADER.OWNER' | translate }}"
          *ngIf="hasRole(ROLE_SUPERADMIN)">{{storage._more.enterpriseName}}</td>
      <td title="{{'TABLE.HEADER.ENTERPRISE' | translate }}">{{storage._more.enterpriseTradeName}}</td>
      <td title="{{'TABLE.HEADER.SUBJECT' | translate }}">{{storage._more.subject }}</td>
      <td title="{{'TABLE.HEADER.SIZE' | translate }}">{{getStorageSize(storage.size)}}</td>
      <td title="{{'TABLE.HEADER.DATE' | translate }}">{{storage.createAt | dateformat}}</td>
      <td title="{{'TABLE.HEADER.STATE' | translate }}">
        <span
          class="{{!storage.active? 'badge badge-danger':''}}">{{storage.active ? ("LABEL.ACTIVE" | translate) : ('LABEL.INACTIVE' | translate)}}</span>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<nav class="Page navigation pagination-custom">
  <div class="row">
    <div class="col-md-8 mt-1">
      <div class="justify-content-row">
        <label class="mr-1 font-weight-normal">Mostrar </label>
        <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                (ngModelChange)="loadStorage(enumPage.First)">
          <option *ngFor="let page of pageNumbers" [value]="page.value"
                  class="font-weight-bold">{{page.value}}</option>
        </select>
        <label class="font-weight-normal"> registros.</label>
      </div>
      <div class="page-total-entries">
        {{ "LABEL.TOTAL-RECORDS" | translate }}
        : {{enterpriseStorageDetails.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
      </div>
    </div>
    <div class="col-md-4">
      <ul class="pagination justify-content-end text-center">
        <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
          <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadStorage(enumPage.First)"
             tabindex="-1" aria-disabled="true">
            <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
            {{ "BUTTON.FIRST" | translate }}
          </a>
        </li>
        <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
          <a class="left {{page.number == 0 ? 'disabled' : ''}}"
             (click)="loadStorage(enumPage.Previous)">
            <i class="fa fa-angle-left" aria-hidden="true"></i></a>
        </li>
        <li
          class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
          <a class="right" (click)="loadStorage(enumPage.Next)"><i
            class="fa fa-angle-right" aria-hidden="true"></i></a>
        </li>
        <li
          class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
          <a class="next" (click)="loadStorage(enumPage.Last)">
            {{ "BUTTON.LAST" | translate }}
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<app-loading *ngIf="loading"></app-loading>
